import { ActivityType, Severity } from '@gripp/shared-logic';
import type { TypeVariant } from './types';

// Mapping between Severity and TypeVariant for crop circle redesign
export const severityToVariant: Record<Severity, TypeVariant> = {
  [Severity.Red]: 'attention',
  [Severity.Yellow]: 'blocker',
  [Severity.Green]: 'done',
  [Severity.Purple]: 'note',
  [Severity.Blue]: 'routines',
};

export const variantToSeverity: Record<TypeVariant, Severity> = {
  attention: Severity.Red,
  blocker: Severity.Yellow,
  done: Severity.Green,
  note: Severity.Purple,
  routines: Severity.Blue,
  urgent: Severity.Red,
  pending: Severity.Yellow,
  solved: Severity.Green,
  campaign: Severity.Purple,
};

// Mapping from ActivityType to TypeVariant for activity-feed row taxonomy.
// Returns undefined for activity types that have no dedicated variant
// (callers should fall back to severity-based mapping).
const activityTypeVariantMap: Partial<Record<ActivityType, TypeVariant>> = {
  [ActivityType.CampaignCreated]: 'campaign',
};

export function activityTypeToVariant(
  activityType: ActivityType
): TypeVariant | undefined {
  return activityTypeVariantMap[activityType];
}
